<script>
export default {
  props: {
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
  },
  
  mounted() {
    console.log(this)
  }
}
</script>

<template>
  <div class="list-wrap">
    <div class="head">
      <div
          class="cell"
          :style="{flex: !column.width ? '1':'',  width: column.width ? `${column.width}` : ''}"
          v-for="(column, index) in columns"
          :key="`${column.prop}_${index}`"
      >
        {{ column.label }}
      </div>
    </div>
    <div class="list-content">
      <template v-if="isEmpty">
        <div class="empty">很遗憾，该奖项轮空啦～</div>
      </template>
      
      <template v-else>
        <div
            v-for="(row, rowIndex) in data"
            :key="rowIndex"
            class="list-row"
        >
          <div
              v-for="(column, colIndex) in columns"
              :key="colIndex"
              :style="{flex: !column.width ? '1':'',  width: column.width ? `${column.width}` : ''}"
              class="list-cell"
          >
            <!-- 渲染插槽内容 -->
            <slot
                :name="column.prop"
                :row="row"
                :rowIndex="rowIndex"
                :colIndex="colIndex"
            >
              <!-- 默认显示字段数据 -->
              {{ row[column.prop] }}
            </slot>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="less">
.list-wrap {
  max-width: 1200px;
  margin: 25px auto 0;
  
  .head {
    display: flex;
    height: 46px;
    font-size: 18px;
    background: linear-gradient(90deg, #dd0e19, #dd0e19, #dd0e19);
    color: #fff;
    
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .list-content {
    .list-row {
      display: flex;
      min-height: 50px;
      
      &:nth-child(2n) {
        background-color: #363fb5;
      }
    }
    
    .list-cell {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  color: #fff;
}
</style>
